module.exports = __webpack_public_path__ + "static/img/download-android.e64ee9d5.png";